import { useContext, useEffect, useState } from 'react';
import { OffersContext } from '../../context/OffersContext';
import { ReactComponent as OfferTag } from '../../assets/icons/offer_tag.svg';
import './offersDetails.css';
import Dialog from '../../components/dialogModal/dialogModal';
import { getOffersData } from '../../api/infoAPI';
import { getFormattedDateReverse } from '../../utils/date';
import ReactLoading from 'react-loading';
import { ReactComponent as TimmerIcon } from '../../assets/icons/trvto_timer_icon.svg';

const OffersDetails = () => {
    const { isOfferPopupOpen, setIsOfferPopupOpen, selectedOfferId, setSelectedOfferId } = useContext(OffersContext);
    const [offersData, setOffersData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchOffer = async () => {
        setLoading(true);
        try {
            const offerResponse = await getOffersData();
            setOffersData(offerResponse.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching offers:', error);
        }
    };

    useEffect(() => {
        fetchOffer();
    }, []);

    const handleOfferCardClick = (id) => {
        setSelectedOfferId(id);
        setIsOfferPopupOpen(true);
    };

    const selectedOfferItem = offersData?.find((offerItem) => offerItem?._id === selectedOfferId);

    return (
        <div className='offerDetailsContainer'>
            {loading ? (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            ) : (
                <>
                    <header className='offerDetailsHeader'>
                        <h1>Offers</h1>
                    </header>
                    <main className='offerMainContent'>
                        {Array.isArray(offersData) &&
                            offersData.length > 0 &&
                            offersData.map((offerItem) => {
                                return (
                                    <div
                                        key={offerItem?._id}
                                        className='offerCardContent'
                                        onClick={() => handleOfferCardClick(offerItem?._id)}
                                    >
                                        <div className='offerCardContentContainer'>
                                            <div className='offer-details-validity-text'>
                                                <div className='offer-details-button-container'>
                                                    <span className='titleText'>Trip</span>
                                                </div>
                                                <div className='offer-details-validityText'>
                                                    <TimmerIcon />
                                                    <span className='offer-details-validText'>
                                                        Validity:{' '}
                                                        {`${getFormattedDateReverse(offerItem?.endsAt) ?? 'N/A'}`}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='offer-details-saveUpToText'>
                                                <span>Save up to ₹{offerItem?.limit}</span>
                                            </div>
                                        </div>
                                        <div className='offer-details-couponCode-Container'>
                                            <button className='offer-details-offerTag'>
                                                <OfferTag width={18} height={18} />
                                            </button>
                                            <span>{offerItem?.code}</span>
                                        </div>
                                    </div>
                                );
                            })}
                    </main>
                    {isOfferPopupOpen && !loading && (
                        <Dialog openModal={isOfferPopupOpen} className={'offerDetailsPopup'}>
                            <div className='offerPopupContentContainer'>
                                <header className='offerPopupHeader'>
                                    <div>Offer Details</div>
                                </header>
                                <hr />
                                <main className='offerMainContentPopup'>
                                    <ul className=''>
                                        <li>
                                            Use code <strong>{selectedOfferItem?.code}</strong> to get{' '}
                                            <strong>{selectedOfferItem?.percentage}%</strong> instant discount on
                                            eligible bookings.
                                        </li>
                                        <li>
                                            Maximum discount available is <strong>₹{selectedOfferItem?.limit}</strong>{' '}
                                            per booking.
                                        </li>
                                        <li>Offer is applicable on selected trip categories only.</li>
                                        <li>Each user can redeem this offer only once.</li>
                                        <li>Offer is non-combinable with any other coupons or promotions.</li>
                                        <li>
                                            Offer validity:{' '}
                                            <strong>
                                                {getFormattedDateReverse(selectedOfferItem?.endsAt || 'N/A')}
                                            </strong>
                                        </li>
                                        <li>
                                            All disputes are subject to <strong>Bengaluru</strong> jurisdiction.
                                        </li>
                                    </ul>
                                </main>
                                <hr />
                                <div className='moreDetailsBtnOffer'>
                                    <button
                                        className='dialogActBtn cancel'
                                        onClick={() => {
                                            setIsOfferPopupOpen(false);
                                            setSelectedOfferId('');
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </Dialog>
                    )}
                </>
            )}
        </div>
    );
};

export default OffersDetails;
